import Link from 'next/link'
import Icon from './Icon'

const InfoItem = ({ href, icon, bgColor = 'bg-primary-20', title, text }) => {
  if (!href) {
    return null
  }

  return (
    <Link href={href}>
      <div className="bg-white p-4 h-32 rounded shadow flex flex-row items-center cursor-pointer">
        <div
          className={`w-16 h-16 flex-shrink-0 rounded items-center justify-center flex ${bgColor}`}
        >
          <Icon name={icon} color="white" size={18} />
        </div>
        <div className="flex flex-col gap-1/2 ml-2 flex-1">
          <h2 className="font-bold">{title}</h2>
          <p className="text-gray-600 text-sm">{text}</p>
        </div>
      </div>
    </Link>
  )
}

export default InfoItem
